<template>
  <div>
    <!-- <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="swiper">
          <div class="pic">
            <img
              src="/static/img/sk/p21-1.jpg"
              width="100%"
              alt="Blueshark R1 PKE"
            />
          </div>
          <div class="text t21">스마트키 & 지문으로 잠금/해제</div>
        </div>
      </swiper-slide>
      <swiper-slide> -->
    <div class="swiper">
      <div class="pic">
        <img
          src="/static/img/p21-1-ch.jpg"
          width="100%"
          alt="Blueshark R1 fingerprint ignition"
        />
      </div>
      <div class="text t21">블루투스 스마트 키</div>
    </div>
    <!-- </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper> -->
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOption: {
        loop: false,
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/swiper.less';
.swiper-pagination {
  bottom: 5vw !important;
}
.t21 {
  bottom: 4vw;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/swiper_sk/swiper21.vue